import { Component as BrComponent, Page } from '@bloomreach/spa-sdk';
import { Component, OnInit } from '@angular/core';
import { CardContent } from '@types';

import { PageSectionContent } from '@types';
import { SectionComponent } from '../section-component.interface';

@Component({
  selector: 'ft-carousel-section',
  templateUrl: './carousel-section.component.html',
  styleUrls: ['./carousel-section.component.scss'],
})
export class CarouselSectionComponent implements OnInit, SectionComponent {
  /**
   * Bloomreach component
   */
  component: BrComponent;

  /**
   * Bloomreach page model
   */
  page: Page;

  labels: any;

  /**
   * Page Section content
   */
  content: PageSectionContent;

  /**
   * Process content.cards to get the exact properties to be feed to EDS component
   */
  cards: CardContent[];

  /**
   * Get processed text
   */
  processedText: string;

  constructor() {}

  /**
   * Populate the component
   * @param component - A parameter
   * @param page - A parameter
   * @param content - A parameter
   */
  populate(
    component: BrComponent,
    page: Page,
    sectionType: string,
    content: PageSectionContent,
    theme: string
  ) {
    this.component = component;
    this.page = page;
    this.content = content;
  }

  ngOnInit(): void {
    /**
     * Bring cards property on root to feed to EDS Media Cards component
     */
    this.cards = [];
    this.content?.cards.forEach((card: CardContent) => {
      // WDE-1449 - adding imgSrc required for EDS component.
      if (!card?.imgSrc && card?.imageSrc) {
        card.imgSrc = card.imageSrc;
      }
      this.cards.push({
        ...card,
        externalLink: card.link?.external,
        isNewWindow: card.link?.target,
        externalSuffix: card.link?.externalSuffix,
      });
    });
    this.labels = this.page?.getComponent('site-configuration')?.getModels()[
      'ft.core.products'
    ];

    /**
     * Remove unwanted tags from the content summary and set it
     */
    this.processedText = this.getText(this.content?.summary);
  }

  /**
   * Get string from HTML
   */
  getText(content: string) {
    // Just remove P HTML tag
    return content?.replace(/<\/?p[^>]*>/gi, '');
  }
}
